import { Navigate, useLocation, useParams } from "react-router-dom";
import { LEGACY_LOCALE_MAP, withLocale } from "../../config/locales";

/**
 * Client-side redirect for legacy URL segments (e.g. /uk/*  → /en-GB/*).
 * Driven entirely by LEGACY_LOCALE_MAP — no hardcoded paths here.
 *
 * Preserves search params and hash so deep-links survive the redirect:
 *   /uk/questions/123?step=2#section → /en-GB/questions/123?step=2#section
 *
 * Registered as the first route(s) in App.js so it fires before any
 * trackPageView side effects see the old URL.
 */
const LegacyLocaleRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const { "*": rest } = useParams();

  const legacyCode = pathname.split("/")[1];
  const targetLocale = LEGACY_LOCALE_MAP[legacyCode];

  if (!targetLocale) return null;

  const subpath = rest ? `/${rest}` : "/";
  const target = withLocale(targetLocale, subpath) + search + hash;

  return <Navigate to={target} replace />;
};

export default LegacyLocaleRedirect;
